import { SET_PROJECT_STATUS_ISVISIBLE } from './constants';

const defaultState = { isVisible: false };

const projectStatusUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_PROJECT_STATUS_ISVISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default projectStatusUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectStatus/reducer.js